import { InstrumentGroupDto } from 'src/store/instrumentgroups/instrumentgroup';
import { ArrayUtils } from 'src/utils/array';
import {
  InstrumentGroupAction,
  InstrumentGroupTypes
} from './instrumentgroups.actions';

export type InstrumentGroupsState = Readonly<{
  instrumentGroups: InstrumentGroupDto[];
  errors: any;
}>;

const initialState: InstrumentGroupsState = {
  instrumentGroups: [],
  errors: null
};

const instrumentGroupsReducer = (
  state: InstrumentGroupsState = initialState,
  action: InstrumentGroupAction
) => {
  switch (action.type) {
    case InstrumentGroupTypes.FetchAll:
      return { ...state, instrumentGroups: action.instrumentGroups };
    case InstrumentGroupTypes.Add:
      return {
        ...state,
        instrumentGroups: [...state.instrumentGroups, action.instrumentGroup]
      };
    case InstrumentGroupTypes.Update:
      return {
        ...state,
        instrumentGroups: ArrayUtils.updateListById(
          state.instrumentGroups,
          action.instrumentGroup
        )
      };
    case InstrumentGroupTypes.Delete:
      return {
        ...state,
        instrumentGroup: null,
        instrumentGroups: ArrayUtils.deleteFromListById(
          state.instrumentGroups,
          action.instrumentGroup
        )
      };
    case InstrumentGroupTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default instrumentGroupsReducer;
